module.exports = __webpack_public_path__ + "media/images/icons/outlined/subnode-ce5d348d6c52f879d90f04f21f1358b1.svg";